import { styled } from '@mui/material/styles';

const MOBILE = '@media (max-width: 600px)';

const STACKED = {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
};

const EQUAL_COLUMNS = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(0, 1fr)',
};

const mobileLayout = inlineOnMobile => (inlineOnMobile ? { ...EQUAL_COLUMNS, gap: 8 } : STACKED);

export const ModalFooter = styled('div')(({ stacked, inlineOnMobile, padding = 0 }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    padding,
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    ...(stacked ? STACKED : { [MOBILE]: { ...mobileLayout(inlineOnMobile), padding: 16 } }),
}));

export const ModalFooterGroup = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 16,
    [MOBILE]: {
        ...EQUAL_COLUMNS,
        padding: 0,
        '&:empty': {
            display: 'none',
        },
        '& > span > button': {
            width: '100%',
        },
        '& > .MuiButtonGroup-root > .MuiButtonGroup-firstButton': {
            flexGrow: 1,
        },
    },
});
